<template lang="pug">
.no-subsidy-repurchase-button(@click="handleClick")
  .button-bg
    img.bg-image(:src="buttonBgImg" alt="按钮背景")
  .button-content
    .main-text {{ content.buttonMainTitle }}
    .sub-text(v-if="content.buttonSubTitle") {{ content.buttonSubTitle }}
  .button-tips(v-if="content.repurchaseCornerMarkTitle") {{ content.repurchaseCornerMarkTitle }}
</template>

<script>
export default {
  name: 'NoSubsidyRepurchaseButton',
  props: {
    content: {
      type: Object,
      default: () => ({
        buttonMainTitle: '',
        buttonSubTitle: '',
        repurchaseCornerMarkTitle: '',
      }),
    },
  },
  data() {
    return {
      // 不补贴复购按钮背景图片 - 对应 Figma 中的 Group 1707484610
      buttonBgImg: 'https://m.hellobike.com/fdb81777_Group%201707484610%202.png', // 需要替换为实际图片地址
    };
  },
  methods: {
    // 处理点击事件
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.no-subsidy-repurchase-button {
  position: relative;
  width: 3.35rem;
  height: 0.915rem;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin: 0.2rem auto 0;

  .button-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .bg-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .button-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 0.62rem;

    .main-text {
      font-size: 0.16rem;
      font-weight: 600;
      color: #fff;
      text-align: center;
      margin-bottom: 0.04rem;
    }

    .sub-text {
      font-size: 0.12rem;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      text-decoration: none;
    }
  }

  .button-tips {
    position: absolute;
    right: 0.38rem;
    top: 0.07rem;
    font-weight: 500;
    font-size: 0.16rem;
    color: #454442;
  }
}
</style>
